export default __webpack_public_path__ + "static/media/icon-review.801a434e.png";